export type FirmwareVersion = {
    project: string // "fw"
    file: string // "ota-fw-1.0.0.bin"
    version: string // "1.0.0"
    buildTime: string // ISO string
    url: string // https://blablabla/fw/file/ota-fw-1.0.0.bin
}

const FW_BASE_URL = process.env.REACT_APP_FW_BASE_URL

function compareVersions(a: string, b: string) {
    const pa = a.split('.').map(Number)
    const pb = b.split('.').map(Number)

    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const na = pa[i] || 0
        const nb = pb[i] || 0

        if (na !== nb) return nb - na // descending
    }
    return 0
}

export async function fetchFirmwareVersions(signal?: AbortSignal): Promise<FirmwareVersion[]> {
    const res = await fetch(`${FW_BASE_URL}/fw/versions`, { signal })
    if (!res.ok) throw new Error(`FW versions fetch failed: ${res.status}`)

    const data = (await res.json()) as FirmwareVersion[]

    return [...data].sort((a, b) => compareVersions(a.version, b.version))
}
